// src/components/SmsStatusMerke.jsx
// Merke for leveringsstatus på én SMS: Levert / Ikke levert / Sendt /
// Ikke bekreftet / Ingen status. Symbol og tekst, ikke bare farge (WCAG 1.4.1).
// Med visGrunn vises tidspunkt (levert) eller grunn (ikke levert) under merket.
import React from "react";
import { smsVisningsstatus, kortSmsTid } from "../utils/smsStatus";

const STIL = {
  levert: "bg-green-100 text-green-900 border-green-400",
  "ikke-levert": "bg-red-100 text-red-900 border-red-400",
  sendt: "bg-blue-100 text-blue-900 border-blue-300",
  "ikke-bekreftet": "bg-amber-100 text-amber-900 border-amber-400",
  ingen: "bg-gray-100 text-gray-700 border-gray-300",
};

const IKON = {
  levert: <path fill="currentColor" d="M6.4 11.6 2.8 8l1.1-1.1 2.5 2.5 5.7-5.7 1.1 1.1z" />,
  "ikke-levert": (
    <path fill="currentColor" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm2.9 8.3-1.1 1.1L8 9.1l-1.8 1.8-1.1-1.1L6.9 8 5.1 6.2l1.1-1.1L8 6.9l1.8-1.8 1.1 1.1L9.1 8z" />
  ),
  sendt: (
    <path fill="currentColor" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm0 11.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm.75-8.5h-1.5v4.1l3.2 1.9.75-1.3-2.45-1.4z" />
  ),
  "ikke-bekreftet": <path fill="currentColor" d="M8 1.2 15.2 14H.8L8 1.2Zm-.75 4.3v4.2h1.5V5.5h-1.5Zm0 5.4v1.5h1.5v-1.5h-1.5Z" />,
  ingen: <path fill="currentColor" d="M3 7.25h10v1.5H3z" />,
};

export default function SmsStatusMerke({ sms, visGrunn = false }) {
  const s = smsVisningsstatus(sms);
  const under =
    s.type === "levert" && s.tid
      ? kortSmsTid(s.tid)
      : s.type === "ikke-levert" || s.type === "ikke-bekreftet"
        ? s.grunn
        : "";

  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <span
        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold ${STIL[s.type]}`}
      >
        <svg viewBox="0 0 16 16" className="h-3.5 w-3.5 flex-none" aria-hidden="true">
          {IKON[s.type]}
        </svg>
        {s.tekst}
      </span>
      {visGrunn && under && (
        <span className={`text-xs ${s.type === "ikke-levert" ? "text-red-800" : "text-gray-600"}`}>
          {s.type === "levert" ? `Levert ${under}` : under}
        </span>
      )}
      {visGrunn && s.detalj && <span className="text-xs text-gray-600 break-words">{s.detalj}</span>}
      {visGrunn && sms?.sendtPaNytt && <span className="text-xs text-gray-600">Sendt på nytt</span>}
    </span>
  );
}
